// extracted by css-extract-rspack-plugin
export default {"container":"TrustPilotDynamicWidget-module__container"};